jQuery_T4NT(document).ready(function($) {


  
     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   //$( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   //});

});

function cartAddMot(var_id) {
  $.post("/cart/add.js", {
    items: [
      {  
        quantity: 1,
        id: var_id,
      },
    ],
    sections: "mini_cart",
  })
    .then(function (res) {
      var elements = $.parseJSON(res).sections.mini_cart;
      var updatedShippingValue = $('.t4s-cart__threshold', elements);
      $('.t4s-cart__threshold').replaceWith(updatedShippingValue);
      
      var updatedCartItems = $('.t4s-mini_cart__items', elements);
      $('.t4s-mini_cart__items').html(updatedCartItems);

      var updatedSubtotal = $('.t4s-drawer__bottom', elements);
      $('.t4s-drawer__bottom').replaceWith(updatedSubtotal);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}